import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"

import cloudImg from "../../images/services/sip/cloud PBX.png"
import callFlowImg from "../../images/services/sip/call flow.png"
import webCallsImg from "../../images/services/sip/sip calls to web.png"

import backgroundImg from "../../images/services/sip/background.svg"

import Constants from "../../constants/services.json"

import CarouselImg1 from "../../images/services/sip/User - services.png"

const carouselData = [
  {
    title: Constants.sip.carouselData.i1.title,
    description: Constants.sip.carouselData.i1.description,
    img: CarouselImg1,
  },
]

const GridData = [
  {
    title: Constants.sip.gridDataArray.i1.title,
    description: Constants.sip.gridDataArray.i1.description,
    img: cloudImg,
  },
  {
    title: Constants.sip.gridDataArray.i2.title,
    description: Constants.sip.gridDataArray.i2.description,
    img: callFlowImg,
  },
  {
    title: Constants.sip.gridDataArray.i3.title,
    description: Constants.sip.gridDataArray.i3.description,
    img: webCallsImg,
  },
]

const SipInt = () => (
  <MainLayout>
    <SEO
      title={Constants.sip.MainLayout.title}
      description="Setup Twilio or Voximplant or your PBX and Integrate it to video conference. What is sip and how sip protocol works. Session initiation protocol(SIP) integration."
      pagePath="/services/sip-integration"
      schema={`{
              "@context": "https://meetrix.io/services/sip-integration",
              "@type": "WebPage",
              "mainEntity": {SIP integration.SIP integration.
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.sip.MainLayout.title}
      description={Constants.sip.MainLayout.description}
      blueTitle={Constants.sip.MainLayout.blueTitle}
      blueLink=""
      background={backgroundImg}
    />
    <GridView
      title={Constants.sip.GridView.title}
      description={Constants.sip.GridView.description}
      data={GridData}
      noButton
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default SipInt
